module.exports = "/_next/static/images/google-play-f2857274a8f4ecd73a67e6fc60e5897c.png";